import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

const MarketingPage = lazy(() => import('../features/marketing/MarketingPage'))
const AdminApp = lazy(() => import('./AdminApp'))

export function AppRouter() {
  return <Suspense fallback={<div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>Loading…</div>}>
    <Routes>
      <Route path="/" element={<MarketingPage />} />
      <Route path="/game" element={<MarketingPage />} />
      <Route path="/admin/*" element={<AdminApp />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </Suspense>
}
